import React from "react";
import { ReactComponent as ClockIcon } from "../../images/dotted_clock.svg";
import { ReactComponent as CloseIcon } from "../../images/close.svg";
import "./TimezoneNotice.scss";

interface TimezoneNoticeProps {
    onDismiss: () => void;
}

const TimezoneNotice: React.FC<TimezoneNoticeProps> = ({ onDismiss }) => {
    return (
        <div className="xgs-pickup-summary__timezone-notice" role="note">
            <ClockIcon className="xgs-pickup-summary__timezone-notice-icon" aria-hidden />
            <p className="xgs-pickup-summary__timezone-notice-text">
                {`Analytics are based on the pickup's origin timezone.`}
            </p>
            <button
                type="button"
                className="xgs-pickup-summary__timezone-notice-close"
                onClick={onDismiss}
                aria-label="Dismiss timezone notice"
            >
                <CloseIcon className="xgs-pickup-summary__timezone-notice-close-icon" aria-hidden />
            </button>
        </div>
    );
};

export default TimezoneNotice;